import React, {useCallback, useState, useEffect} from 'react';
import Wizard from '@ey/canvascoreservices/Wizard';
//pepe
// A Wrapper around voltron wizard components.

// This component recieve wizard steps, buttons and child content for wizard steps.
// Buutons array will have isVisible props that will help to identify if buttons will be visible in current step or not.
// This component also expect currentStepIndex. This will provide the currently active steps in wizard.

// No need to have seprate validation as validation is already handled in each step inside childs components.
// On next click, Parent will update setContinueToNextStep to true.
//      => Child (ex- step 1) if finds ContinueToNextStep is true, it will perform validation and if good.. will update currentStepIndex
//      => This wrapper will listen currentStepIndex and will update current step
//      => This approach can also handler the scenerio where user needs to navigate to specific step as we just need to update currentStepIndex in parent


function WizardWrapper(props) {
    const {wizardSteps, setWizardSteps, buttons, stepContent, currentStepIndex, theme} = props;

    useEffect(() => {
        // Update active flag in wizard steps
        let updatedWizardSteps = wizardSteps.map((step, index) => {
            return {...step, active: index === currentStepIndex ? true : false}
        });
        setWizardSteps(updatedWizardSteps);
	}, [props.currentStepIndex]);

    return (
		<Wizard
			key={wizardSteps.find(s => s.active).stepName}      // using active step label as key
            activeStep={currentStepIndex}
            steps={wizardSteps}
            buttons={buttons.filter(b => b.isVisible == true)}
            theme={theme}
        >
            {stepContent.map((step) => {
                return step
            })}
        </Wizard>
    );
}

export default WizardWrapper;